import { NAV_LINKS } from "@/data/content";
import { Phone, Mail } from "lucide-react";

const Footer = () => (
  <footer data-testid="footer" className="bg-foreground text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <img src="/assets/logo.png" alt="On Time Couriers" className="h-16 w-auto bg-white rounded-xl p-1.5" />
        <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
          Specialized medical courier services. Fast, reliable, and professional delivery — your
          delivery, our priority.
        </p>
      </div>

      <div>
        <h4 className="text-sm font-bold uppercase tracking-wider text-white/90">Quick Links</h4>
        <ul className="mt-4 space-y-2">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a href={l.href} className="text-sm text-white/70 hover:text-white transition-colors">{l.label}</a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-bold uppercase tracking-wider text-white/90">Contact</h4>
        <ul className="mt-4 space-y-3 text-sm text-white/70">
          <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-primary" /> (888) 271-4255</li>
          <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-primary" /> Fordss4@courierson.com</li>
          <li>Mon–Sat: 6AM – 10PM</li>
          <li>Proudly serving the DMV Area</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} On Time Couriers LLC. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
